import { render, staticRenderFns } from "./student_distances.vue?vue&type=template&id=95b7cf5c&"
import script from "./student_distances.vue?vue&type=script&lang=js&"
export * from "./student_distances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports